import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import OperatorParamsLoader from "~/operatorApplication/ts/service/OperatorParamsLoader";
import operatorCometListenerInit from "~/operatorApplication/ts/service/comet/OperatorCometListenerInit";
import operatorLogout from "~/operatorApplication/ts/service/status/OperatorLogout";
import OperatorApplicationAutomaticTemplates
    from "~/operatorApplication/ts/service/dialog/OperatorApplicationAutomaticTemplates";
import {OperatorApplicationDialogsStore} from "~/operatorApplication/ts/store/OperatorApplicationDialogsStore";
import AutoAfk from "~/operatorApplication/ts/service/status/AutoAfk";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {
    CHANGE_SPELLCHECK_CONFIG,
    OPERATOR_LOGGED_IN,
    OPERATOR_RELOAD_APP_CONFIG,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";

let authorizedOnce = false;


let spellcheckWatcher = () => {
    OperatorApplicationPlatform.setSpellcheckLanguages(OperatorApplicationConfigInstance.spellcheckLanguages);
}
OperatorApplicationEventManager.addEventListener(CHANGE_SPELLCHECK_CONFIG, () => spellcheckWatcher());

export default async function operatorLogin(login: string, password: string, currentCometTime: number) {
    ClientUserdataStore.clear();
    authorizedOnce = true;
    try {
        OperatorApplicationDialogsStore.reset();
        await OperatorAccountStore.logIn({login, password});
        AutoAfk.init();
        if (await OperatorParamsLoader.reload(true, "login")) {
            operatorCometListenerInit(currentCometTime);

            if (!OperatorAccountStore.isCabinetIframe) {
                OperatorApplicationAutomaticTemplates.fetchFromServer();
            }
        }
        OperatorApplicationEventManager.emit(OPERATOR_RELOAD_APP_CONFIG, OperatorApplicationConfigInstance);
        OperatorApplicationEventManager.emit(OPERATOR_LOGGED_IN);
        spellcheckWatcher();
    } catch (e) {
        operatorLogout("Возникла ошибка во время авторизации");
    }
}

export function isAuthorizedOnce() {
    return authorizedOnce;
}